// extracted by mini-css-extract-plugin
export default {"blockNext":"InterventionAssessmentWidget_blockNext__oUarx"};